export default __webpack_public_path__ + "static/media/firefly.9a9de364.png";